// extracted by mini-css-extract-plugin
export default {"root":"IconInquiry_root__Z-34n","marketplaceColorStroke":"IconInquiry_marketplaceColorStroke__oIvEw"};